let DestinationType = {
  HOTEL: { id: 1, name: 'HOTEL', translationField: 'hotel'},
  CITY: { id: 2, name: 'CITY', translationField: 'city'},
  SPECIAL_DESTINATION: { id: 3, name: 'SPECIAL_DESTINATION', translationField: 'specialDestination'},
};

export default DestinationType;



// WEBPACK FOOTER //
// ./src/enums/DestinationType.js